/* ===========================================================================
   ANTHOLOGY PUBLISHING PROCESS — page runtime.

   SOURCE OF TRUTH: design-system/ui_kits/website/anthologies.html, the LAST
   <script> block. This file is that block VERBATIM — no changes at all.

   Every routine no-ops when its section is absent, so the file is safe on a
   template that renders only some of the sections.
   =========================================================================== */

/* ══════════════════════════════════════════════════════════════════════
   Anthology Publishing Process — vanilla port of the handoff's DCLogic
   class. Same behaviour, no framework. Everything is scoped to
   .tws-antho so the locked chrome, the co-author testimonials and the
   footer are never touched.

   Dropped from the handoff as dead code: _initNums (no [data-num] in the
   markup), _initGets (no .gt — its section is not in the export), the
   #scrollRail branch of _initScrollFX (that element lived in the
   handoff's own header, which this page does not use) and onSubmit (the
   handoff's newsletter form is not used).
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  var TITLES = ['Choose & submit','Review & selection','Confirm your place','Shape the book','Production','Print & publication'];
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  /* Both reveal mechanisms below make content invisible first and animate it
     back. Under "Reduce motion" the animation never runs, so they are skipped
     entirely rather than left holding the content hidden. */
  var REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- headline type: every word rises out of its own mask ----
     .ac-item headings are excluded on purpose: those panels are the
     homepage's mechanism and their h3s animate by colour, not by mask. */
  function splitWords() {
    var heads = $$('.tws-antho h1, .tws-antho h2, .tws-antho h3').filter(function (h) {
      return !(h.closest && h.closest('.ac-item'));
    });
    var wrap = function (el) {
      Array.prototype.slice.call(el.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          if (!n.textContent.trim()) return;
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var s = document.createElement('span'); s.className = 'sw';
            var i = document.createElement('i'); i.textContent = p;
            s.appendChild(i); frag.appendChild(s);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !n.hasAttribute('data-nosplit') &&
                   !n.classList.contains('sw') && n.tagName !== 'svg' &&
                   n.tagName !== 'BUTTON' && n.tagName !== 'A') { wrap(n); }
      });
    };
    heads.forEach(function (h) {
      if (h.getAttribute('data-split')) return;
      h.setAttribute('data-split', '1');
      wrap(h);
      var words = h.querySelectorAll('.sw');
      var fire = function () {
        words.forEach(function (w, i) { w.classList.add('on'); w.firstChild.style.animationDelay = (i * 52) + 'ms'; });
      };
      if (h.getBoundingClientRect().top < innerHeight * 0.9 || typeof IntersectionObserver === 'undefined') { fire(); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { fire(); io.disconnect(); } });
      }, { threshold: 0.15 });
      io.observe(h);
    });
  }

  /* ---- reveals: only what starts below the fold is hidden ---- */
  function initReveal() {
    if (REDUCE) return;                       // leave everything visible
    var els = $$('.tws-antho [data-rv]');
    if (!els.length || typeof IntersectionObserver === 'undefined') return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var kind = el.getAttribute('data-rv') || 'rise';
        var d = parseInt(el.getAttribute('data-rv-d') || '0', 10);
        el.style.animation = kind + ' .78s cubic-bezier(.22,.7,.25,1) ' + d + 'ms both';
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top > innerHeight * 0.88) { el.style.opacity = '0'; io.observe(el); }
    });
  }

  /* ---- the week ruler draws its bars, staggered ---- */
  function initBars() {
    var rows = $$('.tws-antho .bar-fill');
    if (!rows.length) return;
    if (REDUCE || typeof IntersectionObserver === 'undefined') {
      rows.forEach(function (r) { r.classList.add('on'); });   // never leave a bar at scaleX(0)
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        en.target.style.transitionDelay = (parseInt(en.target.getAttribute('data-d') || '0', 10)) + 'ms';
        en.target.classList.add('on');
      });
    }, { threshold: 0.3 });
    rows.forEach(function (r) { io.observe(r); });
  }

  /* ---- one rAF loop: the stage spine that draws itself, plus parallax ---- */
  function initScrollFX() {
    var rowsWrap = $('#sgRows'), fill = $('#sgFill'), numEl = $('#sgNum'), titleEl = $('#sgTitle');
    var rows = rowsWrap ? $$('.sg-row', rowsWrap) : [];
    var pars = $$('.tws-antho [data-par]');
    var lastActive = -1;
    var apply = function () {
      if (rowsWrap && fill && rows.length) {
        var r = rowsWrap.getBoundingClientRect();
        var span = Math.max(1, r.height - 32);
        var h = Math.max(0, Math.min(span, innerHeight * 0.5 - (r.top + 16)));
        fill.style.height = h.toFixed(1) + 'px';
        var active = -1, i;
        for (i = 0; i < rows.length; i++) {
          if (rows[i].getBoundingClientRect().top < innerHeight * 0.55) active = i;
        }
        if (active !== lastActive) {
          rows.forEach(function (el, i) { if (i <= active) el.classList.add('on'); else el.classList.remove('on'); });
          if (numEl) numEl.textContent = active >= 0 ? '0' + (active + 1) : '01';
          if (titleEl) {
            /* the name comes from each stage's "Short name" field, carried on the
               row as data-short, so adding or reordering stages just works.
               TITLES stays only as a fallback for a block left blank. */
            var ti = active >= 0 ? active : 0;
            var shortName = rows[ti] && rows[ti].getAttribute('data-short');
            titleEl.textContent = shortName || TITLES[ti] || '';
          }
          lastActive = active;
        }
      }
      pars.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -240 || r.top > innerHeight + 240) return;
        var c = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
        var amt = parseFloat(el.getAttribute('data-par')) || 0;
        el.style.setProperty('--py', (-c * amt * 100).toFixed(1) + 'px');
      });
    };
    var queued = false;
    var run = function () { queued = false; try { apply(); } catch (e) {} };
    var onScroll = function () { if (queued) return; queued = true; requestAnimationFrame(run); };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    setInterval(run, 260);
    run();
  }

  /* ---- 04 · WHAT YOU RECEIVE — the homepage's "A home for writers" driver ----
     Ported from index.html unchanged except for one generalisation: the
     homepage hard-codes a 0.26 step because it has exactly four panels. Here
     the step is derived from the panel count, so 4 panels still gives 0.26 and
     this page's 6 give 0.156 — the last panel opens at 88% of the pin either
     way. Below 760px the CSS unpins the section, so we instead open whichever
     panel sits nearest the viewport centre. */
  function initReceive() {
    var sec = $('.tws-antho .ac-sec');
    if (!sec) return;
    var items  = $$('.ac-item', sec);
    var fill   = $('.ac-fill', sec);
    var numBig = $('.ac-num-big', sec);
    if (!items.length) return;

    var LEAD = 0.10, SPAN = 0.78;
    var step = items.length > 1 ? SPAN / (items.length - 1) : SPAN;

    var idx = -1;        /* which panel is open (-1 = all closed) */
    var manualY = null;  /* scrollY at the moment the user clicked a panel */
    var chosen = false;  /* the user has opened a panel by hand at least once */

    function held() { return manualY !== null && Math.abs(window.scrollY - manualY) < 40; }

    function paint(next) {
      if (next === idx) return;
      idx = next;
      for (var i = 0; i < items.length; i++) items[i].setAttribute('data-open', i === idx ? '1' : '0');
      if (numBig) numBig.textContent = idx < 0 ? '00' : '0' + (idx + 1);
    }

    /* the section is pinned only while its first child is actually sticky */
    function isPinned() {
      var st = sec.firstElementChild;
      return !!st && getComputedStyle(st).position === 'sticky';
    }

    function progress() {
      var r = sec.getBoundingClientRect();
      return Math.min(1, Math.max(0, -r.top / Math.max(1, r.height - window.innerHeight)));
    }

    function apply() {
      if (manualY !== null && !held()) manualY = null;

      var next;
      if (isPinned()) {
        var p = progress();
        if (fill) fill.style.height = Math.min(100, Math.max(0, ((p - LEAD) / SPAN) * 100)).toFixed(1) + '%';
        next = p < LEAD ? -1 : Math.max(0, Math.min(items.length - 1, Math.floor((p - LEAD) / step)));
      } else {
        /* Unpinned (the narrow tier): scroll drives NOTHING. The homepage opens
           whichever panel sits nearest the viewport centre, but on a phone that
           reads as the list rearranging itself under your thumb. Here the panels
           stay shut until the reader taps one, and a tapped panel stays open. */
        if (!chosen && idx !== -1) { paint(-1); if (fill) fill.style.height = '0%'; }
        return;
      }
      if (next != null && !held()) paint(next);
    }

    /* click/tap a panel to open it (and hold it) — toggles closed if re-clicked */
    items.forEach(function (it, i) {
      it.addEventListener('click', function () { chosen = true; manualY = window.scrollY; paint(idx === i ? -1 : i); });
    });

    var queued = false;
    function run() { queued = false; try { apply(); } catch (e) {} }
    /* rAF alone is throttled whenever the tab/pane is hidden, so keep the design
       file's belt-and-braces scheduling: a 40ms timeout as well as the frame, and
       a slow interval so the panels are always in sync with the scroll position. */
    function onScroll() { if (queued) return; queued = true; requestAnimationFrame(run); setTimeout(run, 40); }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    setInterval(run, 250);
    run();
  }

  /* ---- FAQ: one open at a time ---- */
  function initFaq() {
    var faqs = $$('#faq details.faq');
    /* The first card no longer opens itself (user decision, 8 Aug 2026).
       `if (faqs[0]) faqs[0].open = true;` used to sit here and overrode the
       markup, so deleting the `open` attribute alone did nothing. The
       toggle listener below still closes the others. */
    faqs.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        faqs.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  /* ---- in-page jumps from the hero contents rail ---- */
  function initGoto() {
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-goto]') : null;
      if (!t) return;
      e.preventDefault();
      var el = document.getElementById(t.getAttribute('data-goto'));
      if (!el) return;
      scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + scrollY - 130), behavior: 'smooth' });
    });
  }

  function init() {
    splitWords(); initReveal(); initBars(); initScrollFX(); initReceive(); initFaq(); initGoto();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
